export const subjectAreaOptions = [
  'A History / Social Science',
  'B English',
  'C Mathematics',
  'D1 - Biological Science',
  'D2 - Physical Science',
  'D Science',
  'E Language Other than English',
  'F Visual & Performing Arts',
  'G College-Preparatory Elective',
  'Non A-G Course',
];

/**
 * Display label for an A-G subject area value (ClickUp 86ak9ab4g, A-G chip format).
 * Stored values stay untouched ("D1 - Biological Science", "B English"); only the
 * text shown to the user becomes "<code>: <name>", e.g. "D1: Biological Science".
 * Values without a leading A-G code ("Non A-G Course", empty) are returned as-is.
 */
export const formatAgAreaLabel = (value?: string | null): string => {
  const raw = (value ?? '').trim();
  // Code is D1/D2 or a single letter A-G, followed by optional spaces/hyphen/colon.
  const match = raw.match(/^(D[12]|[A-G])(?:\s*[-:]\s*|\s+)(.+)$/);
  return match ? `${match[1]}: ${match[2].trim()}` : raw;
};

/* { value: discipline, type: A-G Subject Area } */
export const subjectOptions = [
  { value: '--', type: '' },
  { value: 'Civics/American Government', type: 'A History / Social Science' },
  { value: 'U.S. History', type: 'A History / Social Science' },
  { value: 'World History/Cultures/Hist. Geography', type: 'A History / Social Science' },
  { value: 'English', type: 'B English' },
  { value: 'English-ESL/ELD', type: 'B English' },
  { value: 'Additional Math', type: 'C Mathematics' },
  { value: 'Algebra I', type: 'C Mathematics' },
  { value: 'Algebra II', type: 'C Mathematics' },
  { value: 'Algebra II/Trigonometry', type: 'C Mathematics' },                                 // added 2025-06-27
  { value: 'Calculus', type: 'C Mathematics' },
  { value: 'Computer Science', type: 'C Mathematics' },                                        // added 2025-06-27
  { value: 'Geometry', type: 'C Mathematics' },
  { value: 'Mathematics I', type: 'C Mathematics' },                                           // added 2025-07-03
  { value: 'Mathematics II', type: 'C Mathematics' },                                          // added 2025-07-03
  { value: 'Mathematics III', type: 'C Mathematics' },                                         // added 2025-07-03
  { value: 'Mathematics I (Integrated)', type: 'C Mathematics' },
  { value: 'Mathematics II (Integrated)', type: 'C Mathematics' },
  { value: 'Mathematics III (Integrated)', type: 'C Mathematics' },
  { value: 'Other Advanced Mathematics', type: 'C Mathematics' },
  { value: 'Pre-Calculus', type: 'C Mathematics' },
  { value: 'Statistics', type: 'C Mathematics' },

  { value: 'Biology/Life Sciences', type: 'D1 - Biological Science' },
  { value: 'Biology/Earth & Space Sciences', type: 'D1 - Biological Science' },
  { value: 'Chemistry', type: 'D2 - Physical Science' },
  { value: 'Chemistry/Earth & Space Sciences', type: 'D2 - Physical Science' },
  { value: 'Physics', type: 'D2 - Physical Science' },
  { value: 'Physics/Earth & Space Sciences', type: 'D2 - Physical Science' },
  { value: 'Integrated Science 1', type: 'D2 - Physical Science' },
  { value: 'Integrated Science 2', type: 'D2 - Physical Science' },
  { value: 'Integrated Science 3', type: 'D2 - Physical Science' },
  { value: 'Applied Science', type: 'D2 - Physical Science' },
  { value: 'Computer Science', type: 'D2 - Physical Science' },
  { value: 'Earth & Space Sciences', type: 'D2 - Physical Science' },
  { value: 'Engineering', type: 'D2 - Physical Science' },
  { value: 'Interdisciplinary Sciences', type: 'D2 - Physical Science' },

  { value: 'Applied Science', type: 'D Science' },                                              // added 2025-07-03
  { value: 'Biology/Earth & Space Sciences', type: 'D Science' },                               // added 2025-06-27
  { value: 'Biology/Life Sciences', type: 'D Science' },                                        // added 2025-06-27
  { value: 'Chemistry', type: 'D Science' },                                                    // added 2025-07-03
  { value: 'Chemistry/Earth & Space Sciences', type: 'D Science' },                             // added 2025-07-03
  { value: 'Computer Science', type: 'D Science' },                                             // added 2025-07-03
  { value: 'Earth & Space Sciences', type: 'D Science' },                                       // added 2025-06-27
  { value: 'Engineering', type: 'D Science' },                                                  // added 2025-06-27
  { value: 'Integrated Science', type: 'D Science' },                                           // added 2025-07-03
  { value: 'Integrated Science 1', type: 'D Science' },                                         // added 2025-07-03
  { value: 'Integrated Science 2', type: 'D Science' },                                         // added 2025-07-03
  { value: 'Integrated Science 3', type: 'D Science' },                                         // added 2025-07-03
  { value: 'Interdisciplinary Sciences', type: 'D Science' },                                   // added 2025-06-27
  { value: 'Physics', type: 'D Science' },                                                      // added 2025-07-03
  { value: 'Physics/Earth & Space Sciences',  type: 'D Science' },                              // added 2025-07-07
  { value: 'Yr 1 Lang Other Than English', type: 'E Language Other than English' },
  { value: 'Yr 2 Lang Other Than English', type: 'E Language Other than English' },
  { value: 'Yr 3 Lang Other Than English', type: 'E Language Other than English' },
  { value: 'Yr 4+ Lang Other Than English', type: 'E Language Other than English' },
  { value: 'LOTE Level 1', type: 'E Language Other than English' },                              // added 2025-06-27
  { value: 'LOTE Level 2', type: 'E Language Other than English' },                              // added 2025-06-27
  { value: 'LOTE Level 3', type: 'E Language Other than English' },                              // added 2025-06-27
  { value: 'LOTE Level 4+', type: 'E Language Other than English' },                             // added 2025-06-27
  { value: 'Dance ', type: 'F Visual & Performing Arts' },
  { value: 'Interdisciplinary', type: 'F Visual & Performing Arts' },                            // added 2025-06-27
  { value: 'Interdisciplinary Arts', type: 'F Visual & Performing Arts' },
  { value: 'Music', type: 'F Visual & Performing Arts' },
  { value: 'Theater', type: 'F Visual & Performing Arts' },
  { value: 'Visual Arts', type: 'F Visual & Performing Arts' },
  { value: 'Elective - English', type: 'G College-Preparatory Elective' },
  { value: 'Elective - ESL/ELD', type: 'G College-Preparatory Elective' },
  { value: 'Elective - History/Social Science', type: 'G College-Preparatory Elective' },
  { value: 'Elective - Interdisciplinary', type: 'G College-Preparatory Elective' },
  { value: 'Elective - Interdisciplinary Sciences', type: 'G College-Preparatory Elective' },    // added 2025-06-27
  { value: 'Elective - Language Other than English', type: 'G College-Preparatory Elective' },
  { value: 'Elective - Mathematics', type: 'G College-Preparatory Elective' },
  { value: 'Elective - Math-Computer Science', type: 'G College-Preparatory Elective' },
  { value: 'Elective - Science - Biology/Life Sciences', type: 'G College-Preparatory Elective' },
  { value: 'Elective - Science - Integrated Science', type: 'G College-Preparatory Elective' },
  { value: 'Elective - Science - Physical Science', type: 'G College-Preparatory Elective' },
  { value: 'Elective - Visual & Performing Arts', type: 'G College-Preparatory Elective' },
  { value: 'Physical Education/Health', type: 'Non A-G Course' },
  { value: 'Religion', type: 'Non A-G Course' },
];

export const getSubjectsByType = (type: any) => {

  try {
    if (type === 'E Language Other than English') {
      return subjectOptions.filter((o) => {
        return o.type === type && !o.value.includes('LOTE Level');
      });
    }

    let list:any[] = subjectOptions.filter((o) => {
      return o.type === type;
    });

    if (list.length > 0) {
      list.push({ value: 'Other', type: '' });
      return list;
    }
  } catch (ex) {
    // skip
  }
  return subjectOptions;
};

// exact list - no Other adding
export const getSubjectsByTypeEx = (type: any) => {
  try {
    let list = subjectOptions.filter((o) => {
      return o.type === type;
    });

    if (list.length > 0) {
      return list;
    }
  } catch (ex) {
    // skip
  }
  return subjectOptions;
};

export const scheduleOptions = ['Semester', 'Trimester', 'Quarters', 'Yearly', 'Other'];
export const schoolYearOptions = [
  { id: '2000-2001', name: '2000-01' },
  { id: '2001-2002', name: '2001-02' },
  { id: '2002-2003', name: '2002-03' },
  { id: '2003-2004', name: '2003-04' },
  { id: '2004-2005', name: '2004-05' },
  { id: '2005-2006', name: '2005-06' },
  { id: '2006-2007', name: '2006-07' },
  { id: '2007-2008', name: '2007-08' },
  { id: '2008-2009', name: '2008-09' },
  { id: '2009-2010', name: '2009-10' },
  { id: '2010-2011', name: '2010-11' },
  { id: '2011-2012', name: '2011-12' },
  { id: '2012-2013', name: '2012-13' },
  { id: '2013-2014', name: '2013-14' },
  { id: '2014-2015', name: '2014-15' },
  { id: '2015-2016', name: '2015-16' },
  { id: '2016-2017', name: '2016-17' },
  { id: '2017-2018', name: '2017-18' },
  { id: '2018-2019', name: '2018-19' },
  { id: '2019-2020', name: '2019-20' },
  { id: '2020-2021', name: '2020-21' },
  { id: '2021-2022', name: '2021-22' },
  { id: '2022-2023', name: '2022-23' },
  { id: '2023-2024', name: '2023-24' },
  { id: '2024-2025', name: '2024-25' },
  { id: '2025-2026', name: '2025-26' },
  { id: '2026-2027', name: '2026-27' },
  { id: '2027-2028', name: '2027-28' },
];

export const gradingScaleOptions = [
  { value: 'A-F' },
  { value: '0-100' },
  { value: '0-105' },
  { value: '0-110' },
  { value: '0.0-4.0' },
  { value: '0.0-5.0' },
  { value: '1-7 (IB)' },
  { value: '1-10' },
  { value: '1-11' },
  { value: '1-20' },
  { value: 'Other' },
];

/** Numeric / GPA-style scales — option values must be strings so Select + JSON round-trip match. */
export const NUMERIC_GRADING_SCALES = [
  '0-100',
  '0-105',
  '0-110',
  '1-100',
  '0.0-4.0',
  '0.0-5.0',
  '1-7 (IB)',
  '1-7',
  '1-10',
  '1-11',
  '1-20',
];

export const PERCENT_NUMERIC_SCALES = ['0-100', '0-105', '0-110', '1-100'];

export const isNumericGradingScale = (scale?: string) =>
  !!scale && NUMERIC_GRADING_SCALES.includes(scale);

/** Percent scales written by Courses (0-100) and historically by SchoolConfig (1-100). */
export const isPercentNumericScale = (scale?: string) =>
  !!scale && PERCENT_NUMERIC_SCALES.includes(scale);

/** Flatten Select options into comparable string keys (null stays null). */
export const gradingOptionKeys = (options: any[]) => {
  const keys = new Set<string | null>();
  (options || []).forEach((opt) => {
    if (opt === null || opt === undefined) {
      keys.add(null);
    } else if (typeof opt === 'string' || typeof opt === 'number') {
      keys.add(String(opt));
    } else if (opt?.value !== undefined && opt?.value !== null) {
      keys.add(String(opt.value));
    }
  });
  return keys;
};

/** Coerce stored numeric grades to strings so they match Select option values after reload. */
export const normalizeCourseGradesToStrings = (course: any) => {
  if (!course || !isNumericGradingScale(course.CMGradingScale)) return course;
  const subjects = course.subjectDetails;
  if (!Array.isArray(subjects)) return course;
  subjects.forEach((subject: any) => {
    if (!subject) return;
    if (Array.isArray(subject.grade)) {
      subject.grade = subject.grade.map((g: any) =>
        g === null || g === undefined || g === '' ? g : String(g)
      );
    }
    if (typeof subject.finalGrade === 'number') {
      subject.finalGrade = String(subject.finalGrade);
    }
  });
  return course;
};
export const gradingScale2Options = [
  { value: 'Letter' },
  { value: 'Numbers' },
  { value: 'Other' },
  { value: 'This school does not provide grades' },
];

export const AToFGrade = [
  //null,   // move out 2025-08-22
  'A+',
  'A',
  'A-',
  'B+',
  'B',
  'B-',
  'C+',
  'C',
  'C-',
  'D+',
  'D',
  'D-',
  //'E',  // remove 2025-01-09
  'F',
  'Incomplete',
  'No Grade',
  'Fail - (Pass/Fail)',
  'Pass - (Pass/Fail)',
  'S - Satisfactory',
  'U- Unsatisfactory',
  'Withdrawn',
  'Withdrawn - Failed',
  'Medical Excuse',
];
export const to100Grade = [
  //null,   // move out 2025-08-22
  'Incomplete',
  'No Grade',
  'Fail - (Pass/Fail)',
  'Pass - (Pass/Fail)',
  'S - Satisfactory',
  'U- Unsatisfactory',
  'Withdrawn',
  'Withdrawn - Failed',
  'Medical Excuse',
];
export const to4Grade = [
  //null,   // move out 2025-08-22
  'Incomplete',
  'No Grade',
  'Fail - (Pass/Fail)',
  'Pass - (Pass/Fail)',
  'S - Satisfactory',
  'U- Unsatisfactory',
  'Withdrawn',
  'Withdrawn - Failed',
  'Medical Excuse',
];
export const classOptionEnglish = [
  { value: 'Communications' },
  { value: 'English/Language Arts I' },
  { value: 'English/Language Arts II' },
  { value: 'English/Language Arts III' },
  { value: 'English/Language Arts IV' },
  { value: 'Public Speaking' },
  { value: 'English Other' },
];
export const classOptionHistory = [
  { value: 'Ancient Civilizations' },
  { value: 'Ancient and Medieval History' },
  { value: 'Anthropology' },
  { value: 'Business Law' },
  { value: 'Civics' },
  { value: 'Comparative Government' },
  { value: 'Consumer Law' },
  { value: 'International Relations' },
  { value: 'Law Studies' },
  { value: 'Legal System' },
  { value: 'Macroeconomics' },
  { value: 'Medieval European History' },
  { value: 'Microeconomics' },
  { value: 'Modern European History' },
  { value: 'Philosophy' },
  { value: 'Political Science' },
  { value: 'Psychology' },
  { value: 'Sociolgy' },
  { value: 'State-Specific Studies' },
  { value: 'U.S. Ethnic Studies' },
  { value: 'U.S. Gender Studies' },
  { value: 'U.S. Geography' },
  { value: 'U.S. Government' },
  { value: 'U.S. History' },
  { value: 'United States and World Affairs' },
  { value: 'Western Civilization' },
  { value: 'World Geography' },
  { value: 'World History' },
  { value: 'History/Social Science-Other' },
];
export const classOptionLaboratory = [
  'Aerospace',
  'Anatomy',
  'Astronomy',
  'Biology',
  'Botany',
  'Chemistry',
  'Earth Science',
  'Environmental Science',
  'Genetics',
  'Geology',
  'Integrated Science',
  'Life Science',
  'Marine Science',
  'Meteorology',
  'Nutrition Science',
  'Organic Chemistry',
  'Physical Chemistry',
  'Physcial Geography',
  'Physical Science',
  'Physics',
  'Physiology',
  'Zoology',
  'Laboratory Scicence-Other',
];
export const classOptionForeign = [
  'American Indian Language I - V',
  'American Indian Literature',
  'American Sign Language I-V',
  'Arabic I-V',
  'Arabic Literature',
  'Braille',
  'Chinese I-V',
  'Chinese Literature',
  'Classical Greek I-V',
  'Classical Hebrew I-V',
  'Filipino I-V',
  'Filipino Literature',
  'French I-V',
  'French Literature',
  'German I-V',
  'German Literature',
  'Greek I-V',
  'Greek Literature',
  'Hebrew I-V',
  'Hebrew Literature',
  'Italian I-V',
  'Italian Literature',
  'Japanese I-V',
  'Japanese Literature',
  'Korean I-V',
  'Korean Literature',
  'Latin I-V',
  'Portuguese I-V',
  'Portuguese Literature',
  'Russian I-V',
  'Russian Literature',
  'Spanish I-V',
  'Spanish Literature',
  'Swahili I-V',
  'Swahili Literature',
  'Vietnamese I-V',
  'Vietnamese Literature',
  'Language Other Than English-Other',
];
export const classOptionMath = [
  'Algebra I-III',
  'Calculus',
  'Calculus AB',
  'Calculus BC',
  'Differential Calculus',
  'Discrete Mathematics',
  'Finite Mathematics',
  'Geometry',
  'Integraded Mathematics I-IV',
  'Linear Algebra',
  'Multivariate Calculus',
  'Pre-Algebra',
  'Pre-Calculus',
  'Statistics',
  'Trigonometry',
  'Math-Other',
];

export const classTypeOption = [
  'Regular/Standard',
  'Accelerated',
  'Advanced',
  'Advanced Placement (AP)',
  'AS/A-level/International A-level, Cambridge AICE',
  'College Prep',
  'Dual Enrollment',
  'Enriched',
  'GCSE, IGCSE',
  'Gifted',
  'High Honors',
  'Honors',
  'Intensive',
  'International Baccalaureate (IB)',
  'Pre-IB',
  'Regents',
  'N/A',
  // 'Advanced / Honors',
  // 'Advanced Placement (AP)',
  // 'Cambridge AICE',
  // 'International Baccalaureate Higher Level(IB HL)',
  // 'International Baccalaureate Standard Level(IB SL)',
  // 'Regents',
  // 'Running Start',
  // 'Other',
];


// Updated 2026-08-31: each option now carries which application(s) accept this AP exam
// (Common App / UC / CSU). Used to auto check/uncheck and enable/disable the
// "Include test info into these applications" checkboxes in APSubjectConfig.tsx.
// optionName = the value shown/stored for the exam (same string as the previous plain list).
export const cmSubjectTestOption = [
  { optionName: 'African American Studies', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Art History', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Art: 2-D Art & Design', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Art: 3-D Art & Design', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Art: Drawing', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Biology', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Business with Personal Finance', CommonApp: true, UC: false, CSU: false }, // NEW 2026-08-31 - Common App only
  { optionName: 'Calculus AB', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Calculus AB Subscore', CommonApp: false, UC: true, CSU: true }, // NEW 2026-08-31 - subscore from the BC sitting, UC & CSU only
  { optionName: 'Calculus BC', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Chemistry', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Chinese Language & Culture', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Computer Science A', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Computer Science Principles', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Cybersecurity', CommonApp: true, UC: true, CSU: false }, // NEW 2026-08-31 - Common App + UC only
  { optionName: 'Economics: Macroeconomics', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Economics: Microeconomics', CommonApp: true, UC: true, CSU: true },
  { optionName: 'English Language & Composition', CommonApp: true, UC: true, CSU: true },
  { optionName: 'English Literature & Composition', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Environmental Science', CommonApp: true, UC: true, CSU: true },
  { optionName: 'European History', CommonApp: true, UC: true, CSU: true },
  { optionName: 'French Language & Culture', CommonApp: true, UC: true, CSU: true },
  { optionName: 'German Language & Culture', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Government & Politics: Comparative', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Government & Politics: United States', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Human Geography', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Italian Language & Culture', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Japanese Language & Culture', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Latin', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Music Theory', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Networking', CommonApp: true, UC: true, CSU: false }, // NEW 2026-08-31 - Common App + UC only
  { optionName: 'Physics 1', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Physics 2', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Physics C - Electricity & Magnetism', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Physics C Mechanics', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Precalculus', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Psychology', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Research', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Seminar', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Spanish Language & Culture', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Spanish Literature & Culture', CommonApp: true, UC: true, CSU: true },
  { optionName: 'Statistics', CommonApp: true, UC: true, CSU: true },
  { optionName: 'United States History', CommonApp: true, UC: true, CSU: true },
  { optionName: 'World History', CommonApp: true, UC: true, CSU: true },
];
